import { useEffect, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";

export default function CompanySelect({ value, onChange, allowAll = false, testId = "company-select" }) {
  const [companies, setCompanies] = useState([]);
  useEffect(() => { api.get("/companies").then((r) => setCompanies(r.data)).catch(() => {}); }, []);
  return (
    <Select value={value || (allowAll ? "all" : undefined)} onValueChange={(v) => onChange(v === "all" ? "" : v)}>
      <SelectTrigger className="w-full sm:w-60" data-testid={testId}><SelectValue placeholder="Select company" /></SelectTrigger>
      <SelectContent>
        {allowAll && <SelectItem value="all">All companies</SelectItem>}
        {companies.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
